import React, { useEffect } from "react";
// import HoolvaTelcom from '../components/HoolvaTelcom'

import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { env } from "../config";
import * as Actions from "../redux/actions";
import Loader from "../components/Loader";
import VoinfinityTelcom from "../components/VoinfinityTelcom";
import HRMnestSection from "../components/HRMnestSection";
import DigitalTransformationdescription from "../components/FohikSection";
import ContactUsSection from "../components/ContactUsSection";
import Footer from "../components/Footer";

function TelecomPage() {
  const TelecomData: any = useSelector(
    (state: any) => state?.Page?.TelecomPageContent
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        await axios
          .get(`${env}/api/product-page-content?populate=deep`)
          .then(async (response: any) => {
            dispatch(
              Actions.TelecomPageAction(response?.data?.data?.attributes)
            );
          })
          .catch((error: any) => {
            console.log("error", error);
          });
      })();
    }, 0);

    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
  }, [dispatch]);

  const isLoading = Object.keys(TelecomData)?.length === 0;

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="">
        <div
          style={{
            backgroundImage: `url(${env}${TelecomData?.intro?.Image?.data?.attributes?.url})`,
          }}
          className={` bg-no-repeat bg-cover  text-white  bg-center flex flex-col justify-center items-center gap-10`}
        >
          <div
            data-aos="zoom-out"
            className=" font-custom font-bold  text-2xl py-[7%] md:py-[10%] px-[1%] sm:text-3xl md:text-4xl xl:text-5xl bg-[#000000] w-full h-full bg-opacity-50  flex flex-col gap-4 text-center items-center justify-center"
          >
            <div data-aos="fade-down" className="lg:w-[75%] xl:w-[50%]">
              {TelecomData?.intro?.Title}
            </div>
            <div
              data-aos="fade-down"
              className="lg:w-[75%] xl:w-[50%] font-custom font-normal text-base  lg:text-lg text-center  px-4 py-2"
            >
              {TelecomData?.intro?.Description}
            </div>
          </div>
        </div>
      </div>
      {TelecomData?.section?.map((node: any, index: number) => {
        if (node?.product?.toLowerCase() === "ncs") {
          return (
            <VoinfinityTelcom
              key={index + node?.product}
              TelecomVoifinitySection={
                TelecomData?.section?.filter(
                  (node: { product: string }) =>
                    node?.product.toLowerCase() === "ncs"
                )[0]
              }
            />
          );
        } else if (node?.product?.toLowerCase() === "fohik") {
          return (
            <DigitalTransformationdescription
              key={index + node?.product}
              DigitalTransformationDescription={node}
              Cards={node?.ProductCard}
            />
          );
        } else {
          return (
            <HRMnestSection
              imgPosition="rounded-lg"
              key={index + node?.product}
              product={node}
            />
          );
        }
      })}
      <ContactUsSection ContactUsSection={TelecomData?.ConnectSection} />
      <Footer />
    </>
  );
}

export default TelecomPage;
